import { render } from "./BalanceSheetShop.vue?vue&type=template&id=51bd327e"
import script from "./BalanceSheetShop.vue?vue&type=script&lang=js"
export * from "./BalanceSheetShop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__